module.exports = __webpack_public_path__ + "static/media/LPPoliceLogo.4f962b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LPPoliceLogo.png
// module id = 1903
// module chunks = 0